import { WcsShippingMethods } from './wcs/shipping-methods'
import { WcsShippingMethod } from '@/scripts/libs/wcs/types/shipping-method'
import { ShippingMethod } from '@/types/shipping-methods'
import { SHIPPING_METHODS } from '../constants/shipping-methods'
import { BUTTONS_DISABLED } from '../constants/css-classes'

export class ShippingMethods {
  static async getShippingMethods(): Promise<Record<string, ShippingMethod>> {
    const shippingMethods = await WcsShippingMethods.fetchShippingMethods()
    const normalizedShippingMethods = this.normalizeShippingMethods(shippingMethods)
    return normalizedShippingMethods
  }

  private static normalizeShippingMethods(
    methods: WcsShippingMethod[]
  ): Record<string, ShippingMethod> {
    const shippingMethods = {} as Record<string, ShippingMethod>

    methods.sort((firstMethod, secondMethod) => firstMethod.priority - secondMethod.priority)

    methods.forEach((method) => {
      shippingMethods[method.type] = {
        default: method.default,
        freeLabel: method.promoBadge,
        id: method.type,
        isBops:
          SHIPPING_METHODS.PICKUP_POINT === method.type || SHIPPING_METHODS.BOSS === method.type,
        isSfs: SHIPPING_METHODS.SHIP_FROM_STORE === method.type,
        note: method.note,
        price: method.price,
        selected: method.selected,
        shipNoId: method.shipModeIds[0],
        title: method.title,
        time: method.time,
      }
    })

    return shippingMethods
  }

  static getSelectedShippingMethod() {
    const selectedShippingMethod = localStorage.getItem('selectedShippingMethod')

    return selectedShippingMethod
  }

  static setSelectedShippingMethod(selectedShippingMethod: string) {
    if (selectedShippingMethod) {
      localStorage.setItem('selectedShippingMethod', selectedShippingMethod)
    }
  }

  static clearSavedMethodFromStorage() {
    localStorage.removeItem('selectedShippingMethod')
  }

  static disableBodyButtons() {
    document.querySelector('body')?.classList.add(BUTTONS_DISABLED)
  }

  static enableBodyButtons() {
    document.querySelector('body')?.classList.remove(BUTTONS_DISABLED)
  }

  static setSelectedStore(selectedStoreId: string) {
    if (selectedStoreId) {
      localStorage.setItem('selectedStoreId', selectedStoreId)
    }
  }
}
